document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.coll-view a')) document.querySelectorAll('.coll-view a').forEach((grid) => {
    grid.addEventListener('click',function(e){
      e.preventDefault();
      localStorage.setItem("collection_grid", grid.getAttribute('data-view'));
      document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
      const desk_grids = document.querySelectorAll(".coll-view a.active");
      desk_grids.forEach((desk_grid) => {
        desk_grid.classList.remove("active");
      });
      grid.classList.add("active");
    });
  });
});
function filterWrapper(){
  if(document.querySelectorAll('.facet-list')) document.querySelectorAll('.facet-list').forEach(filter_wrap => {
    let filter_cont = filter_wrap.querySelector('.coll-filter-wrap');
    let filter_btn = filter_wrap.querySelector('.filter-btn');
    filter_btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      let filter_open = filter_wrap.querySelector('.coll-filter-inr.active-filter');
      let filter_box_height = filter_btn.closest('.facet-list').querySelector('.coll-filter-wrap .filter-list').offsetHeight;
      if(!filter_open){
        if(window.outerWidth > 991) filter_btn.closest('.facet-list').querySelector('.coll-filter-wrap').style.height = filter_box_height+'px';
        if(window.outerWidth > 991 && filter_box_height >= 275) filter_btn.closest('.facet-list').querySelector('.coll-filter-wrap').style.overflow = 'auto';
        filter_btn.closest('.facet-list').querySelector('.coll-filter-inr').classList.add('active-filter');
        document.querySelector('body').classList.add('open-filter');
      }else{
        if(window.outerWidth > 991) filter_btn.closest('.facet-list').querySelector('.coll-filter-wrap').style.height = '';
        if(window.outerWidth > 991 && filter_box_height >= 275) filter_btn.closest('.facet-list').querySelector('.coll-filter-wrap').style.overflow = '';
        filter_btn.closest('.facet-list').querySelector('.coll-filter-inr').classList.remove('active-filter');
        document.querySelector('body').classList.remove('open-filter');
      }
      document.querySelectorAll('.facet-list').forEach(filterClose => {
        if(filterClose !== filter_wrap){
          if(window.outerWidth > 991) filterClose.querySelector('.coll-filter-wrap').style.height = '';
          filterClose.querySelector('.coll-filter-inr').classList.remove('active-filter');        
        }
      });
    });
  });
  if(document.querySelectorAll('.overlay-box,.filter-mb-close,.filter-mb-close')) document.querySelectorAll('.overlay-box,.filter-mb-close').forEach(function(filterMbClose){
    filterMbClose.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelector('body').classList.remove('open-filter','open-sort');
      if(document.querySelector('.facet-list .coll-filter-inr.active-filter')) document.querySelector('.facet-list .coll-filter-inr.active-filter').classList.remove('active-filter');
    });
  });
}
function collView(){
  if(localStorage.getItem("collection_grid") == null){
    localStorage.setItem("collection_grid", document.querySelector(".coll-view a.active").getAttribute('data-view'));
  }else{
    document.querySelector(".collection-grid").setAttribute('data-desk',localStorage.getItem("collection_grid"));
    if(document.querySelector(".coll-view a.active")){
      if(document.querySelector(".coll-view a.active").getAttribute('data-view') != localStorage.getItem("collection_grid")){
        document.querySelector(".coll-view a.active").classList.remove('active')
        let deskGrids = document.querySelectorAll(".coll-view a");
        deskGrids.forEach((deskGrid) => {
          let desk_val = deskGrid.getAttribute('data-view')
          if(parseInt(desk_val) == parseInt(localStorage.getItem("collection_grid"))){
            deskGrid.classList.add('active')
          }
        });
      }
    }
  }
}
collView();
filterWrapper();
class FacetFiltersForm extends HTMLElement{
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      if(event.target.name == 'sort_by'){
        document.querySelector('.sort-button strong').textContent = event.target.getAttribute('data-val');
        document.querySelector('.sort-button strong').setAttribute('data-val',event.target.value)
        const sortsOpen = document.querySelectorAll(".sort-box ul li.active");
        sortsOpen.forEach((sortOpen) => {
          sortOpen.classList.remove("active");
        });
        event.target.parentElement.classList.add('active');
        if(window.outerWidth > 991) event.target.parentElement.closest('.sort-box-wrap').style.minWidth = '204px';
        if(window.outerWidth > 991) event.target.parentElement.closest('.sort-box').querySelector('.filter-sort').style.width = '';
        if(window.outerWidth > 991) event.target.parentElement.closest('.sort-box').querySelector('.filter-sort').style.height = document.querySelector('.sort-box .filter-sort ul').offsetHeight + 'px';
      }
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    collView();
    filterWrapper();
    let sort_btn = document.querySelector('.sort-button');
    if(sort_btn) sort_btn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
      if(window.outerWidth > 991){
        if(document.querySelector('body').classList.contains('open-sort')){
          let sort_btn_width = sort_btn.offsetWidth+51;
          let sort_btn_box = sort_btn.closest('.sort-box').querySelector('.filter-sort ul').offsetWidth;
          if(sort_btn_width <= 204){
            event.target.parentElement.closest('.sort-box-wrap').style.minWidth = '204px';
          }else if(sort_btn_width > sort_btn_box){
            sort_btn.closest('.sort-box').querySelector('.filter-sort').style.width = sort_btn_width+'px';
          }else{
            sort_btn.closest('.sort-box').querySelector('.filter-sort').style.width = sort_btn_box+'px';
          }
          sort_btn.closest('.sort-box').querySelector('.filter-sort').style.height = sort_btn.closest('.sort-box').querySelector('.filter-sort ul').offsetHeight+'px';
        }else{
          sort_btn.closest('.sort-box').querySelector('.filter-sort').style.width = '100%';
          event.target.parentElement.closest('.sort-box-wrap').style.minWidth = '';
          sort_btn.closest('.sort-box').querySelector('.filter-sort').style.height = '0px';
        }
      }
    });
    if(document.querySelector('.sort-box')){
      if(document.querySelector('.sort-box')) document.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    const clearAllButton = document.getElementById('clear-all-filters');
    if(clearAllButton){
      clearAllButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.clearAllFilters();
      });
    }
  }
  clearAllFilters(){
    const form = this.querySelector('form');
    form.reset();
    let searchParams = new URLSearchParams();
    const availabilityFilter = "filter.v.availability=1";
    searchParams.set("filter.v.availability", 1);
    FacetFiltersForm.renderPage(searchParams.toString());
  }
  static setListeners(){
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      FacetFiltersForm.updateFiltersAndSorts(searchParams);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static updateFiltersAndSorts(searchParams) {
    const filterSections = document.querySelectorAll('.filter-index');
    filterSections.forEach(section => {
      const selectedFilters = section.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
      const count = selectedFilters.length;
      if(section.closest('.coll-filter-inr')){
        const filterCountElement = section.closest('.coll-filter-inr').querySelector('.filter-count');
        if (filterCountElement) {
          filterCountElement.textContent = count > 0 ? `${count}` : '';
        }
      }
    });
    const params = new URLSearchParams(searchParams);
    const filterInputs = document.querySelectorAll('.filter-index input[type="checkbox"]');
    filterInputs.forEach(input => {
      const name = input.name;
      const value = input.value;
      input.checked = params.has(name) && params.getAll(name).includes(value);
    });
    document.querySelector('.filter-sort.filter-index').style.height = '';
    document.querySelector('body').classList.remove('open-filter','open-sort');
    if(document.querySelector('.facet-list .coll-filter-inr.active-filter')) document.querySelector('.facet-list .coll-filter-inr.active-filter').classList.remove('active-filter');
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if(updateURLHash){
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }
  static renderSectionFromFetch(url, event){
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
        collView();
        filterWrapper();
        // document.querySelector('body').classList.remove('open-filter');
        // if(document.querySelectorAll('.facet-list.active-filter')){
        //   document.querySelector('.facet-list.active-filter .coll-filter-wrap').style.height = document.querySelector('.facet-list.active-filter .coll-filter-wrap .filter-list').offsetHeight+'px';
        // }
      }
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if(typeof quickAddButton == 'function'){
      quickAddButton();
      collView();
      filterWrapper();
      // document.querySelector('body').classList.remove('open-filter');
      // if(document.querySelectorAll('.facet-list.active-filter')){
      //   document.querySelector('.facet-list.active-filter .coll-filter-wrap').style.height = document.querySelector('.facet-list.active-filter .coll-filter-wrap .filter-list').offsetHeight+'px';
      // }
    }
  }
  static renderProductGridContainer(html){
    document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
    document.querySelector('.coll-count').textContent = count;
    // window.scrollTo({ top: (document.querySelector('.section-end-of-page-section').offsetTop - window.innerHeight), behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  static renderFilters(html, event){
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
    const updateFilterCounts = () => {
      const filterSections = document.querySelectorAll('.filter-index');
      filterSections.forEach(section => {
        const selectedFilters = section.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        const count = selectedFilters.length;
        if(section.closest('.coll-filter-inr')){
          const filterCountElement = section.closest('.coll-filter-inr').querySelector('.filter-count');
          if (filterCountElement) {
            filterCountElement.textContent = count > 0 ? `${count}` : '';
          }
        }
      });
    };
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    if(event){
      if(event.target.closest('.coll-filter-wrap')){
        const clearButton = event.target.closest('.coll-filter-wrap').querySelector('.filter-clear-btn .button');
        if(clearButton) clearButton.removeAttribute('disabled');
      }
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      if(document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`)) document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
    updateFilterCounts();
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ];
  }
  onSubmitHandler(event) {
    const filterCheck=(params)=>{
      let available = params.match(/filter/g)
      if(available === null){
        available = 0
      }else{
        available = available.length
      }
      return available
    }
    event.preventDefault();
    let formData = new FormData(event.target.closest('.section-collection').querySelector('form'));
    let searchParams = new URLSearchParams(formData).toString();

    const result = filterCheck(searchParams)
    if(!(searchParams.includes("availability"))){
      if(result > 0){
        searchParams = searchParams + "&filter.v.availability=1";
      }
    }else if(result < 2){
      searchParams = searchParams.replace("filter.v.availability=1&", "");
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect();
document.addEventListener('click', function(e){
  let tags = document.querySelectorAll('.filter-index, .sort-button');
  let isClickInside = false;
  tags.forEach(function(element){
    if (element.contains(e.target) || element === e.target) isClickInside = true;
  });
  if(!isClickInside){
    document.body.classList.remove('open-sort', 'open-filter');
    if(document.querySelector('.sort-box-wrap')) document.querySelector('.sort-box-wrap').style.minWidth = '0px';
    document.querySelectorAll('.filter-index').forEach(function(filterElement) {
      filterElement.style.height = '0px';
      if(filterElement.closest('.coll-filter-inr')) filterElement.closest('.coll-filter-inr').classList.remove('active-filter');
    });
  }
});